module.exports = __webpack_public_path__ + "img/logo-MeetingHubwSlogan4.5700fb49.png";